export default __webpack_public_path__ + "static/media/logoGrad.672bb30f.svg";